/* eslint-disable react/require-default-props */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-restricted-syntax */
/* eslint-disable react/destructuring-assignment */
import { ActionIcon, Group, OptionsFilter, Select } from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import { IconBuildingSkyscraper, IconRefresh } from '@tabler/icons-react';
import { useEffect, useState } from 'react';
import { EntitySearchResponseType } from '../../../models/core/entities.type';
import entitiesService from '../../../services/core/entities.service';
import theme from '../../../theme';
import { EntityItemEnum } from '../../../utils/constants.utils';
import { transformComboBoxGroupDataFromV5toV7 } from '../../../utils/mantine.utils';
import ProfileCardLink from '../ProfileCardLink/ProfileCardLink';

type FormViewProps = {
  item: EntityItemEnum;
  itemId: number;
  label: string;
  formItem: any;
  idsToBeDisabled: number[];
  disabled: boolean;
  required?: boolean;
  callback(item: EntitySearchResponseType | null): void;
  zIndex: number;
};

export default function EntityItemPicker(props: FormViewProps) {
  const [data, setData] = useState<EntitySearchResponseType[]>([]);
  const [loading, setLoading] = useState(false);

  const confirmActionResult = (item: EntitySearchResponseType | null, confirmed: boolean) => {
    if (!confirmed) {
      return;
    }
    props.callback(item);
  };

  const loadData = async () => {
    try {
      setLoading(true);

      let result: EntitySearchResponseType[] = [];

      switch (props.item) {
        case EntityItemEnum.Packaging:
          result = await entitiesService.searchByPackagingId({
            idResiduoAcondicionamento: props.itemId,
          });
          break;
        case EntityItemEnum.Destination:
          result = await entitiesService.searchByDestinationId({
            idResiduoDestinoFinal: props.itemId,
          });
          break;
        case EntityItemEnum.Equipment:
          result = await entitiesService.searchByEquipmentId({
            idResiduoEquipamento: props.itemId,
          });
          break;
        case EntityItemEnum.Service:
          result = await entitiesService.searchByServiceId({
            idServico: props.itemId,
          });
          break;
        case EntityItemEnum.Treatment:
          result = await entitiesService.searchByTreatmentId({
            idResiduoTratamento: props.itemId,
          });
          break;
        case EntityItemEnum.Vehicle:
          result = await entitiesService.searchByVehicleId({
            idResiduoVeiculo: props.itemId,
          });
          break;
        default:
          break;
      }

      setData(result);
    } catch (error: any) {
      showNotification({
        title: `Fornecedor - Pesquisar`,
        message: error?.isBusinessException ? error.description : 'Não foi possível pesquisar entidades.',
        color: 'red',
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (props.itemId > 0) {
      loadData();
    }
  }, []);

  const handleRefresh = () => {
    loadData();
  };

  const optionsFilter: OptionsFilter = ({ options, search }) => {
    if (search.trim().length === 0) {
      return options;
    }

    const filteredData = data
      .filter((x) => {
        const value = `${x.idEntidade}|${x.nomeFantasia || ''}|${x.razaoSocial || ''}|${x.cnpj || ''}|${
          x.nome || ''
        }|${x.cpf || ''}`;
        return value.toLowerCase().includes(search.toLowerCase());
      })
      .map((y) => y.idEntidade?.toString());

    const filteredOptions = [];
    for (const option of options) {
      const items = (option as any).items.filter((x: any) => filteredData.includes(x.value));
      if (items.length > 0) {
        filteredOptions.push({
          ...option,
          items,
        });
      }
    }
    return filteredOptions;
  };

  return (
    <Group grow preventGrowOverflow={false} wrap="nowrap">
      <Select
        key={`entity-item-picker_${props.formItem.value?.toString()}`}
        leftSection={<IconBuildingSkyscraper size={15} />}
        label={props.label}
        placeholder="Selecione..."
        data={transformComboBoxGroupDataFromV5toV7(
          data.map((x) => {
            return {
              label: `# ${x.idEntidade} - ${x.nomeFantasia || x.razaoSocial || x.nome || ''}`,
              value: x.idEntidade.toString(),
              disabled: props.idsToBeDisabled.includes(x.idEntidade),
              group: (x.nomeFantasia || x.razaoSocial || x.nome || '-').toUpperCase()[0],
            };
          })
        ).sort((a, b) => a.group.localeCompare(b.group))}
        clearable
        searchable
        filter={optionsFilter}
        disabled={props.disabled || loading}
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        renderOption={({ option, checked }) => {
          const row = data.find((x) => x.idEntidade!.toString() === option.value)!;
          if (row.idEntidade) {
            if (row.cnpj) {
              return (
                <ProfileCardLink
                  id={row.idEntidade.toString()}
                  name={row.nomeFantasia || row.razaoSocial || '-'}
                  nameSize="sm"
                  description={row.nomeFantasia ? row.razaoSocial : row.cnpj}
                  descriptionSize="xs"
                  linkPrefix="entities"
                  showLink={false}
                />
              );
            }
            return (
              <ProfileCardLink
                id={row.idEntidade.toString()}
                name={row.nome || '-'}
                nameSize="sm"
                description={row.cpf}
                descriptionSize="xs"
                linkPrefix="entities"
                showLink={false}
              />
            );
          }
          return '-';
        }}
        required={props.required}
        {...props.formItem}
        value={props.formItem.value?.toString()}
        onOptionSubmit={(value: string) => {
          confirmActionResult(data.find((x) => x.idEntidade.toString() === value) || null, true);
        }}
        comboboxProps={{ zIndex: props.zIndex + 1 }}
      />
      <ActionIcon
        style={{ marginLeft: -10, marginTop: 20, maxWidth: 15 }}
        radius="sm"
        color="primary"
        variant="outline"
        onClick={handleRefresh}
        disabled={props.disabled || loading}
        loading={loading}
      >
        <IconRefresh size={15} color={theme?.colors?.primary?.[6]} />
      </ActionIcon>
    </Group>
  );
}
